import { Buffer } from 'buffer';

/// <reference lib="dom" />
let buffer;
if (typeof globalThis?.Buffer !== "undefined") {
    buffer = globalThis.Buffer;
}
else {
    buffer = Buffer;
}

export { buffer };
//# sourceMappingURL=universal.mjs.map
